import { get$, post$, silence } from 'services/api';
import { User } from './types';

export type AuthResponse = {
  token: string;
  user: User;
};

export type LoginBody = {
  email: string;
  password: string;
};

export type RegisterBody = {
  email: string;
  password: string;
  name: string;
  code: string;
};

export type ForgotBody = {
  email: string;
};

export type ResetBody = {
  email: string;
  password: string;
  nonce: string;
};

export const apiLogin = (body: LoginBody) =>
  post$<AuthResponse>('/login', body);

export const apiRegister = (body: RegisterBody) =>
  post$<AuthResponse>('/register', body);

export const apiMe = () => get$<AuthResponse>('/me').catch(silence());

export const apiForgot = (body: ForgotBody) => post$<any>('/forgot', body);

export const apiReset = (body: ResetBody) => post$<any>('/reset', body);
